import React from "react";
function PageTitle() {
    return (
        <>
            <br />
            <br />
            <br />
            <br />
            {/* <!-- page-title --> */}
            <div className="tf-page-title">
                <div className="container-full">
                    <div className="row">
                        <div className="col-12">
                            <div className="heading text-center">New Arrival</div>
                            <p className="text-center text-2 text_black-2 mt_5">Shop through our latest selection of Fashion</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- /page-title --> */}


        </>
    )
}
export default PageTitle;